(function() {
  if (!['/pages/restore-before-replace-golf-club-care-kit', '/pages/golf-club-care-kit'].includes(window.location.pathname)) return;

  var reviews = [
    {
      key: 'lisa-marino',
      quote: '“When I gave him the kit he was skeptical and very hesitant to try the products. After one use, however, he was sold especially with the grip cleaner! Now maybe I can talk him into cleaning my clubs…hmmm”',
      attribution: '— Lisa Marino, Verified Buyer'
    },
    {
      key: 'victor-khoury',
      quote: '“I have 3 sets of clubs, one being 25 years old. After cleaning, polishing and grip spritzing, they all look as if made yesterday, most scratches disappeared, and the shine is sparkling...”',
      attribution: '— Victor Khoury, Verified Buyer'
    },
    {
      key: 'john-crowley',
      quote: '“The kit was easy to use. I would say that it is much better than the old, standard wash with soapy water, etc. The price is competitive and it looks like it can be used many times during the year.”',
      attribution: '— John Crowley, Verified Buyer'
    }
  ];

  function addReviews() {
    var section = document.querySelector('section[id$="__multicolumn_yt8xfU"]');
    if (!section) return;
    var list = section.querySelector('.multicolumn-list');
    var items = list && list.querySelectorAll('.multicolumn-list__item');
    var templateItem = items && items[0];
    if (!list || !templateItem || items.length < reviews.length) return;

    reviews.forEach(function(review, index) {
      var item = items[index];
      item.setAttribute('data-rbr-judgeme-real', review.key);
      item.classList.add('rbr-judgeme-real-card');

      var title = item.querySelector('h3, .inline-richtext');
      var rte = item.querySelector('.rte');
      if (title) title.textContent = review.quote;
      if (rte) rte.innerHTML = '<h5><em>' + review.attribution + '</em></h5>';

    });

    Array.prototype.slice.call(items, reviews.length).forEach(function(item) {
      item.remove();
    });

    document.documentElement.classList.add('rbr-judgeme-real-ready');
  }

  addReviews();
  document.addEventListener('DOMContentLoaded', addReviews);
  window.addEventListener('load', addReviews);
  setTimeout(addReviews, 500);
  setTimeout(addReviews, 1500);
})();
